import { h, Component } from 'preact';
import { BaseField } from '../BaseField';

import { bind, memoize, debounce } from 'decko';
import Checkbox from 'preact-material-components/Checkbox';
import FormField from 'preact-material-components/FormField';

import { ICheckBoxListProps, ICheckBoxListState } from './ICheckBoxList';

//let style = require('./style.css');

export class CheckBoxList extends BaseField<ICheckBoxListProps, ICheckBoxListState> {

    constructor(props: ICheckBoxListProps, ctx) {
        super(props, ctx);
        this.setState({
            value : props.value || []
        });
    }

    @bind
    public onChange(value) {
        var idx = this.state.value.indexOf(value);

        var newVal = this.state.value;

        if (idx > -1)
            newVal.splice(idx, 1);
        else
            newVal.push(value);

        this.setState({ value: newVal });

        if (this.props.onChange)
            this.props.onChange(newVal);
    }

    render() {
        var controlledCheckBoxElements = this.props.options.map((option, i) => {
            return (
                <FormField >
                    <Checkbox
                        id={`checkbox-${this.props.name}-${i}`}
                        name={this.props.name}
                        checked={this.state.value.indexOf(option.value)>-1}
                        onChange={() => { this.onChange(option.value) }}
                    />
                    <label for={`checkbox-${this.props.name}-${i}`}>{option.text}</label>
                </FormField>
            );
        });

        return <div class={this.props.class}><label>{this.props.label}</label><div>{controlledCheckBoxElements}</div></div>;
    }
}




// WEBPACK FOOTER //
// ./components/forms/fields/checkBoxList/CheckBoxList.tsx